import Component from '../app/component'
import ImagesParallax from '../plugins/images-parallax.js'

export default class RelatedComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {}
  }

  init () {
    const iParallax = new ImagesParallax(this.refs.images)
  }
}
